import { render, staticRenderFns } from "./AddressSideInfo.vue?vue&type=template&id=52762a2c"
import script from "./AddressSideInfo.vue?vue&type=script&lang=js"
export * from "./AddressSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports